import Vue from 'vue'

export const EventBus = new Vue({
  name: 'conversation-event-bus',
})
